import type { NormalizedImageTransform } from './types';
import { resolveEffectPresetFilters } from './effectPresets';

export function composeCssFilter(transform: NormalizedImageTransform): string {
  const { adjustments, effects } = transform;
  const parts: string[] = [];

  if (adjustments.brightness !== 1) {
    parts.push(`brightness(${adjustments.brightness})`);
  }
  if (adjustments.contrast !== 1) {
    parts.push(`contrast(${adjustments.contrast})`);
  }
  if (adjustments.saturation !== 1) {
    parts.push(`saturate(${adjustments.saturation})`);
  }
  if (adjustments.hueRotate !== 0) {
    parts.push(`hue-rotate(${adjustments.hueRotate}deg)`);
  }
  if (adjustments.blur > 0) {
    parts.push(`blur(${adjustments.blur}px)`);
  }

  const presetParts = resolveEffectPresetFilters(effects.preset);
  parts.push(...presetParts);

  return parts.length ? parts.join(' ') : 'none';
}

export function composeCanvasFilter(transform: NormalizedImageTransform): string {
  return composeCssFilter(transform);
}
